import axios from 'axios';

import { ERROR_URL } from '../utils/urls';
import { getAppHostByRegion } from './i18n.helpers';
import { assign } from './window-utils';

const webappHost = getAppHostByRegion();

const clientHTTP = axios.create({
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  withCredentials: true,
});

export const configInterceptors = () => {
  clientHTTP.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error) {
        const { status } = error?.response;
        const SERVER_ERROR_CODES = [500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511];
        const UNAUTHORIZED_CODE = 401;

        if (status === UNAUTHORIZED_CODE) {
          assign(`${webappHost}`);
        }

        if (SERVER_ERROR_CODES.includes(status)) {
          assign(`${ERROR_URL}?next=${window.location.pathname}`);
        }
      }
      return Promise.reject(error);
    }
  );
};

export default clientHTTP;
